import PortalIdParser from 'PortalIdParser';
const TASK_QUEUE_BAR_STORAGE_KEY_PREFIX = 'LocalSettings:Tasks:TaskQueueBarConfig';
export function getSessionStorageKey(portalId = PortalIdParser.get()) {
  return `${TASK_QUEUE_BAR_STORAGE_KEY_PREFIX}:${portalId}`;
}